import type { ApiResponse, ApiResponseEnvelope } from '@/shared/api/types/api-response'
import type {
  DashboardStats,
  DashboardStatsFilterParams,
  RecentActivity,
} from '@/shared/api/types/dashboard-types'
import { GW, toQueryString } from '@/shared/api/endpoints'
import { unwrapApiEnvelope } from '@/shared/api/utils/unwrapapi'
import { request } from '@/shared/libs/request'

const DASHBOARD_STATS_PATH = 'admin/dashboard/stats'

export async function getDashboardStats(
  filters: DashboardStatsFilterParams = {},
): Promise<ApiResponse<DashboardStats>> {
  const params: Record<string, unknown> = {}
  if (filters.countryId) params['countryId'] = filters.countryId
  if (filters.provinceId) params['provinceId'] = filters.provinceId
  if (filters.isActive !== undefined && filters.isActive !== null)
    params['isActive'] = filters.isActive

  const qs = toQueryString(params)
  const url = qs
    ? GW.packaging(`${DASHBOARD_STATS_PATH}?${qs}`)
    : GW.packaging(DASHBOARD_STATS_PATH)
  const response = await request.get<ApiResponseEnvelope<DashboardStats>>(url)

  return {
    data: unwrapApiEnvelope(response.data),
  }
}

const RECENT_ACTIVITY_PLACEHOLDER: RecentActivity[] = [
  {
    id: 'activity-not-ready',
    type: 'tenant_updated',
    description: 'Recent activity will be available when audit log API is ready.',
    timestamp: new Date().toISOString(),
    entityId: 'dashboard',
  },
]

export async function getRecentActivity(): Promise<ApiResponse<RecentActivity[]>> {
  return {
    data: RECENT_ACTIVITY_PLACEHOLDER,
  }
}
